export const applicationSchema = {
  table: 'applications',
  title: 'Application Form',
  submitUrl: 'http://localhost/nessa/customers/onboard',
  columns: [
    { name: 'customer_id', type: 'int', primaryKey: true, autoIncrement: true },
    { name: 'reference_number', type: 'varchar', length: 100, nullable: true },
    { name: 'fullname', type: 'varchar', length: 180, nullable: false, label: 'Full Name' },
    { name: 'phone', type: 'varchar', length: 20, nullable: true, label: 'Phone' },
    { name: 'email', type: 'varchar', length: 180, nullable: true, label: 'Email' },
    {
      name: 'contact_method',
      type: 'enum',
      nullable: true,
      label: 'Preferred Contact Method',
      options: ['Email', 'Phone', 'WhatsApp']
    },
    {
      name: 'entity_type',
      type: 'enum',
      nullable: true,
      label: 'Business Entity Type',
      options: ['Sole Proprietorship', 'Partnership', 'Limited Liability Company', 'Cooperative', 'Other']
    },
    { name: 'position', type: 'varchar', length: 120, nullable: true, label: 'Position' },
    {
      name: 'requested_services',
      type: 'json',
      nullable: true,
      label: 'Requested Services',
      multiple: true,
      options: ['Accounting', 'Bookkeeping', 'Payroll', 'Taxes', 'Other']
    },
    {
      name: 'vat_registered',
      type: 'enum',
      nullable: true,
      label: 'Are you registered with VAT?',
      options: ['Yes', 'No']
    },
    { name: 'annual_turnover', type: 'decimal', nullable: true, label: 'Annual Turnover' },
    { name: 'annual_revenue', type: 'decimal', nullable: true, label: 'Annual Revenue' },
    { name: 'monthly_transactions', type: 'int', nullable: true, label: 'Number of Monthly Transactions' },
    { name: 'num_of_employees', type: 'int', nullable: true, label: 'Number of Employees' },
    {
      name: 'currency_used',
      type: 'enum',
      nullable: true,
      label: 'Currency',
      options: ['GHS', 'USD', 'EUR']
    },
    { name: 'accounting_software', type: 'varchar', length: 180, nullable: true, label: 'Accounting Software' },
    {
      name: 'ownership_type',
      type: 'enum',
      nullable: true,
      label: 'Ownership Type',
      options: ['Sole Proprietorship', 'Partnership', 'Limited Liability Company', 'Cooperative', 'Other']
    },
    { name: 'other_ownership_type', type: 'varchar', length: 180, nullable: true, label: 'Specify Other Ownership Type' },
    {
      name: 'declare_gdpr',
      type: 'enum',
      nullable: false,
      label: 'I consent to data verification and processing under GDPR.',
      options: ['Yes', 'No'],
      default: 'No'
    }
  ]
};
